import type { EmotionCache } from "@emotion/cache";
import createCache from "@emotion/cache";

export const defaultCache = createEmotionCache();

export function createEmotionCache(): EmotionCache {
  return createCache({ key: "cha" });
}
